import * as React from "react";
import { Button, Dialog, DialogContent, styled } from "@mui/material";
import { MasterClinicWarning } from "../common/MasterClinicWarning";
//region [[ Styles ]]

const JsonEditConformSaveView = styled(Dialog)({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
});

const ButtonArea = styled("div")({
  display: "flex",
  flexFlow: "row-reverse",
  margin: "15px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface JsonEditConformSaveProps {
  onCancel: () => void;
  onApprove: () => void;
  isMasterClinic: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const JsonEditConformSave = ({ ...props }: JsonEditConformSaveProps) => {
  return (
    <JsonEditConformSaveView open onClose={props.onCancel}>
      <DialogContent>
        {props.isMasterClinic && <MasterClinicWarning />}
        You are about to update the settings, this will affect production as
        well, are you sure?
      </DialogContent>
      <ButtonArea>
        <Button onClick={props.onApprove} variant="contained" color="primary">
          Yes
        </Button>
        <Button onClick={props.onCancel}>No</Button>
      </ButtonArea>
    </JsonEditConformSaveView>
  );
};
